import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ImageService {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() {}

  getImageUrl({ fileId }: { fileId: string }) {
    // TODO: download file
    // unpack with zip file

    const imageUrl = ''; // Convert to a fileUrl
    return imageUrl;
  }
}
